export default "__VITE_PUBLIC_ASSET__436111ea__"